import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShareAndroid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M12.5 7a3.5 3.5 0 1 1 .947 2.394l-4 2a3.5 3.5 0 0 1 0 1.212l4 2a3.5 3.5 0 1 1-.895 1.789l-4-2a3.5 3.5 0 1 1 0-4.789l4-2A3.5 3.5 0 0 1 12.5 7'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShareAndroid)
export default ForwardRef
